/* 数据大屏等模块按设计稿宽度换算 rem；不做手机端视口适配（窄屏不调整根字号） */
function getRem(pwidth, prem) {
  var html = document.documentElement;
  var oWidth = document.body.clientWidth || html.clientWidth;
  if (oWidth < 768) {
    html.style.removeProperty("font-size");
    return;
  }
  html.style.fontSize = (oWidth / pwidth) * prem + "px";
}
function initRem() {
  getRem(1920, 100);
}
if (typeof window !== "undefined") {
  window.addEventListener("load", initRem);
  window.addEventListener("resize", initRem);
  initRem();
}